(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/content/simple-article/assets/javascripts/content-loader.js') >= 0) return;  svs.modules.push('/components/content/simple-article/assets/javascripts/content-loader.js'); 'use strict';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var isServer = (typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object';
var imageSizes;
var jupiter;
var logger;
var videoContentLoader;

if (isServer) {
  var trinidad = require('trinidad-core').core;

  jupiter = trinidad.jupiter;
  logger = trinidad.logger('component:content:simple-article');
  imageSizes = trinidad.components.require('content', 'shared').imageSizes;
  videoContentLoader = trinidad.components.require('components', 'video-player');
} else {
  jupiter = {
    call: function call(options, callback) {
      return svs.core.jupiter.call(options, function (data) {
        return callback(null, data);
      }, function (err) {
        return callback(err);
      });
    }
  };
  logger = new svs.core.log.Logger('component:content:simple-article');
  imageSizes = svs.content.shared.imageSizes;
  videoContentLoader = svs.components.video_player.contentLoader;
}


function loadArticle(options, callback) {
  if (!options || !options.url) {
    callback('Required options parameters not supplied');
    return;
  } 


  var jupiterOptions = {
    method: 'GET',
    path: options.url,
    req: options.req
  };

  try {
    jupiter.call(jupiterOptions, function (err, data) {
      if (err) {
        callback(err);
      } else if (!data.result[0]) {
        logger.debug('No article in data response', options.req); 

        callback(null);
      } else {
        prepareArticles(data.result, options, function (err, result) {
          return callback(err, result[0]);
        });
      }
    });
  } catch (e) {
    callback(e);
  }
}


function loadArticles(options, callback) {
  if (!options || !options.url) {
    callback('Required options parameters not supplied');
    return;
  } 


  var jupiterOptions = {
    method: 'GET',
    path: options.url,
    req: options.req
  };

  try {
    jupiter.call(jupiterOptions, function (err, data) {
      if (err) {
        logger.warn("Failed to fetch articles, url: ".concat(options.url), options.req);
        callback("Failed to fetch articles:".concat(err.message));
      } else if (!data.result[0]) {
        callback(null, []);
      } else {
        prepareArticles(data.result, options, callback);
      }
    });
  } catch (e) {
    callback(e);
  }
}

function prepareImages(images, options) {
  return images.map(function (image) {
    image.sizes = imageSizes.getMediaQuery([imageSizes.ENUM.lg, imageSizes.ENUM.xs]);
    image.noscriptUrl = image.url.replace('{width}', options.fallbackImageWidth || '1280'); 

    image.heightPercent = 560 / 1280 * 100;
    return image;
  });
}

function prepareVideos(videos) {
  return videos.map(function (video) {
    if (video.type === 'redbee') {
      try {
        return _objectSpread({
          assetId: video.id,
          businessUnit: 'VOD',
          customer: 'SvenskaSpel',
          src: ''
        }, video);
      } catch (error) {
        logger.warn("Error loading redbee video content: ".concat(error.toString()));
      }
    } else {
      var solidtangoVid;
      videoContentLoader.loadVideo({
        api: false,
        type: video.type,
        videoId: video.id
      }, function (err, loadedVideo) {
        if (err) {
          logger.warn("Error loading solidtango video content: ".concat(err.toString()));
        } else if (loadedVideo) {
          solidtangoVid = _objectSpread({
            name: video.name
          }, loadedVideo);
        }
      });
      return solidtangoVid;
    }

    return [];
  });
}


function prepareArticles(articles, options, callback) {
  var preparedArticles = articles.map(function (article) {
    if (article.images) {
      article.images = prepareImages(article.images, options);
    }

    if (article.videos) {
      article.videos = prepareVideos(article.videos);
    }

    return article;
  });
  callback(null, preparedArticles);
}

if (isServer) {
  module.exports = {
    loadArticle: loadArticle,
    loadArticles: loadArticles,
    prepareArticles: prepareArticles
  };
} else {
  svs.content.simple_article.contentLoader = {
    loadArticle: loadArticle,
    loadArticles: loadArticles,
    prepareArticles: prepareArticles
  };
}
 })(window);